import { Badge } from '@/components/ui/Badge';
import { DataTable } from '@/components/ui/DataTable';
import type { LogEntry } from '@/types/admin.types';
import { formatDateTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';

const columnHelper = createColumnHelper<LogEntry>();

const levelVariant = (l: string) => {
  if (l === 'error') return 'danger';
  if (l === 'warn') return 'warning';
  if (l === 'info') return 'info';
  return 'neutral';
};

const columns = [
  columnHelper.accessor('timestamp', {
    header: 'Date',
    cell: (info) => <span className="text-xs text-neutral-500 whitespace-nowrap">{formatDateTime(info.getValue())}</span>,
  }),
  columnHelper.accessor('level', {
    header: 'Niveau',
    cell: (info) => <Badge variant={levelVariant(info.getValue())}>{info.getValue()}</Badge>,
  }),
  columnHelper.accessor('context', {
    header: 'Contexte',
    cell: (info) => <span className="text-xs text-neutral-600 dark:text-neutral-400 font-mono">{info.getValue()}</span>,
  }),
  columnHelper.accessor('message', {
    header: 'Message',
    cell: (info) => <span className="text-sm text-neutral-700 dark:text-neutral-300 truncate max-w-md block">{info.getValue()}</span>,
  }),
];

interface LogsTableProps {
  data: LogEntry[];
  loading?: boolean;
}

export function LogsTable({ data, loading }: LogsTableProps) {
  return <DataTable columns={columns} data={data} loading={loading} emptyMessage="Aucun log" pageSize={50} />;
}
